import { styled } from "@mui/material/styles";
import { Card, CardHeader, Avatar, Typography, Grid } from "@mui/material";
import { config } from "../../core/service/config.service";

// ----------------------------------------------------------------------

const ChartWrapperStyle = styled("div")(({ theme }) => ({
  height: 300,
  marginTop: theme.spacing(5)
}));

// ----------------------------------------------------------------------

export default function MentorView({ detail }) {
  const { email, middle_name_en, name_en, surname_en, title_name_en } =
    detail || {};

  const name = `${title_name_en || ""} ${name_en || ""} ${
    middle_name_en || ""
  } ${surname_en || ""}`;

  return (
    <Card>
      <CardHeader title="Mentor" />
      <ChartWrapperStyle dir="ltr">
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
        >
          <Avatar
            src={
              detail?.photo
                ? `${config.host_api}user/photo/${detail?.photo}`
                : null
            }
            sx={{ width: 150, height: 150 }}
          />

          <Typography
            variant="h5"
            component="div"
            style={{ paddingTop: "30px" }}
          >
            {name}
          </Typography>

          <Typography component="div" style={{ paddingTop: "15px" }}>
            {email}
          </Typography>
        </Grid>
      </ChartWrapperStyle>
    </Card>
  );
}
